<template>
  <div class="register absolute">
    <div class="register_tit">
      <img @click="fanhui()" src="../../assets/images/licai/fanhui.png" />
      <p class="">{{$t('m.jf_span17')}}</p>
    </div>
    <div class="register_block">
      <div
        style="border-radius:8px;background:#fff;padding:15px 10px 15px 15px;display:flex;align-items:center;position: relative;"
      >
        <div style="flex:1;margin-right:10px;">
          <div style="display:flex;align-items:center;">
            <span
              style="color:#000;font-weight:bold;font-size:18px;margin-right:10px;"
              >{{ dicdata.name }}</span
            >
            <span style="color:#666;font-size:13px;">{{ dicdata.phone }}</span>
          </div>
          <p style="margin-top:10px;font-size:14px;color:#000;">
            {{ dicdata.diqu }}{{ dicdata.address }}
          </p>
        </div>
      </div>
      <div
        style="border-radius:8px;background:#fff;padding:10px 10px 50px 10px;margin-top:10px;"
      >
        <div
          style="font-size:20px;line-height:30px;color:#000;margin-bottom:10px;"
        >
          {{$t('m.jf_span16')}}
        </div>
        <div style="display:flex;">
          <img
            :src="dicdata1.images"
            style="width: 100px;height: 100px;border-radius:8px;margin-right:10px;"
            alt=""
          />
          <div style="position: relative;flex:1;">
            <div style="font-size:17px;color:#000;" class="line-clamp2">
              {{ dicdata1.title }}
            </div>
            <div
              style="position: absolute;left:0px;bottom:0px;color:#666;font-size:13px;"
            >
              <span style="font-size:20px;color:red;font-weight:bold;"
                >{{ dicdata1.price }} </span
              >积分
            </div>
          </div>
        </div>
        <div
          style="display:flex;align-items:center;font-size:14px;margin-top:20px;"
        >
          <span style="width: 105px;color:#000;">{{$t('m.jf_span5')}}</span>
          <span style="color:#666">{{ dicdata1.sketch }}</span>
        </div>
        <div
          style="display:flex;align-items:center;font-size:14px;height: 40px;"
        >
          <span style="width: 105px;color:#000;">{{$t('m.jf_span6')}}</span>
          <span style="color:#666">{{ dicdata.num }}</span>
        </div>
        <div style="display:flex;align-items:center;font-size:14px;">
          <span style="width: 105px;color:#000;">{{$t('m.jf_span7')}}</span>
          <span style="color:#666;flex:1;">{{ dicdata.bz }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";

export default {
  name: "JfOver",
  data: function() {
    return {
      money: "",
      mima: "",
      dicdata: {},
      dicdata1: {}
    };
  },

  mounted: function() {
    this.dicdata = JSON.parse(localStorage.getItem("jifen"));
    let type = this.$route.params.id;
    request
      .get("/shop/goods/good-detail", { id: type }, { login: true })
      .then(res => {
        console.log(res);
        this.dicdata1 = res.data.data;
      })
      .catch(err => {
        this.$dialog.error(err.response.data.msg);
      });
  },
  methods: {
    fanhui: function() {
      this.$router.push({
        path: "/"
      });
    }
  }
};
</script>
<style scoped>
.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.register_block {
  padding: 10px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>

